import {Link} from "react-router-dom";
import Paths from "../constants/Paths";
import React from "react";
import {ReactComponent as Messenger} from '../assets/images/icons/messenger.svg';
import {ReactComponent as Discord} from "../assets/images/icons/discord.svg";
import {ReactComponent as Facebook} from "../assets/images/icons/facebook.svg";
import {ReactComponent as Instagram} from "../assets/images/icons/instagram.svg";
import {ReactComponent as Youtube} from "../assets/images/icons/youtube.svg";
import {ReactComponent as Tiktok} from "../assets/images/icons/tiktok.svg";
import {ReactComponent as Linkedin} from "../assets/images/icons/linkedin.svg";
import {ReactComponent as Twitterx} from "../assets/images/icons/twitterx.svg";
import {ReactComponent as Telegram} from "../assets/images/icons/telegram.svg";

const SocialItemsContainer = () => {

    return (
        <div className="flex flex-row flex-wrap gap-3 mt-2">
            <Link to={Paths.INSTAGRAM} target="_blank" className="social-item-two">
                <div className="social-icon-container">
                    <Instagram alt="instagram"/>
                </div>
                <p>Instagram</p>
            </Link>

            {/*<Link to={Paths.YOUTUBE} target="_blank" className="social-item-two">*/}
            {/*    <div className="social-icon-container">*/}
            {/*        <Youtube alt="youtube"/>*/}
            {/*    </div>*/}
            {/*</Link>*/}

            {/*<Link to={Paths.FACEBOOK} target="_blank" className="social-item-two">*/}
            {/*    <div className="social-icon-container">*/}
            {/*        <Facebook alt="facebook"/>*/}
            {/*    </div>*/}
            {/*</Link>*/}

            <Link to={Paths.TIKTOK_NY} target="_blank" className="social-item-two">
                <div className="social-icon-container">
                    <Tiktok alt="TikTok New York"/>
                </div>
                <p>TikTok<br/>New York</p>
            </Link>

            <Link to={Paths.TIKTOK_L} target="_blank" className="social-item-two">
                <div className="social-icon-container">
                    <Tiktok alt="TikTok London"/>
                </div>
                <p>TikTok<br/>London</p>
            </Link>

            {/*<Link to="" target="_blank" className="social-item-two">*/}
            {/*    <div className="social-icon-container">*/}
            {/*        <Twitterx alt="x"/>*/}
            {/*    </div>*/}
            {/*</Link>*/}

            <Link to={Paths.DISCORD} target="_blank" className="social-item-two">
                <div className="social-icon-container">
                    <Discord alt="discord"/>
                </div>
                <p>Discord</p>
            </Link>
        </div>
    )
}

export default SocialItemsContainer;